import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deleteConfirmationText: {
    defaultMessage: 'Location will be removed. Are you sure?',
    id: 'location.delete.dialog.text',
  },
});
